import Vue from 'vue';
// @ts-expect-error
import VueBarcode from 'vue-barcode/index';

Vue.component('VueBarcode', VueBarcode);
